export interface Province {
    name: string
    municipalities: Municipality[]
}

export interface Municipality {
    name: string
}

export class ProvincesManager {
    provinces: Province[] = []

    constructor(provinces: any) {
        const provinces_keys = Object.keys(provinces)

        provinces_keys.forEach((key) => {
            this.provinces.push({
                name: key,
                municipalities: provinces[key].map((municipality: string) => {
                    return { name: municipality }
                }),
            })
        })
    }

    onlyProvinces() {
        return this.provinces.map((p) => p.name)
    }

    getMunicipalities(province: string) {
        return this.provinces.find((p) => p.name == province)?.municipalities
    }
}
